var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.className,attrs:{"id":_vm.id,"rel":_vm.rel,"href":_vm.href,"title":_vm.title,"target":_vm.target},domProps:{"innerHTML":_vm._s(_vm.parsedLabel)},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }